import { axiosInstance } from "../../utils";

const actions = {
    FETCH_USERS_REQUESTED: 'FETCH_USERS_REQUESTED',
    FETCH_USERS_SUCCEEDED: 'FETCH_USERS_SUCCEEDED',
    FETCH_USERS_FAILED: 'FETCH_USERS_FAILED',

    DELETE_USER_REQUESTED: 'DELETE_USER_REQUESTED',
    DELETE_USER_SUCCEEDED: 'DELETE_USER_SUCCEEDED',
    DELETE_USER_FAILED: 'DELETE_USER_FAILED',

    fetchUsers: (params = undefined) => {
        return {
        type: actions.FETCH_USERS_REQUESTED,
        payload: params
    }},

    getUsers: async (params = undefined) => {
        const url = `users`;

        try {
            const users = await axiosInstance.get(url,{ params });
            return users.data;
        } catch (error) {
            throw error;
        }
    },

    removeUser: (id = undefined) => {
        return {
            type: actions.DELETE_USER_REQUESTED,
            payload: id
        }
    },

    deleteUser: async (id = undefined) => {
        const url = `users/` + id;
        
        try {
            const response = await axiosInstance.delete(url);
            return response;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
